import React from 'react';
import PropTypes from 'prop-types';

import FilterInputV2 from './FilterInputV2';
import FilterDate from './FilterDate';
import FilterToggle from './FilterToggle';
import './Filters.css';

function ListFilterContainer({ filters, active, onValid, style }) {
  const componentFilters = {
    'text': FilterInputV2,
    'date': FilterDate,
    'toggle': FilterToggle
  };

  return active ? (
    <div className={`flexRow list-filter-container`} style={style}>
      {filters && filters.map( (x,i) => React.createElement(componentFilters[x.type_factory], { 
        key: `f-${x.type}`,
        flexShrink: x.shrink,
        type: x.type,
        placeholder: x.label,
        value: x.value,
        onValid: onValid,
        inputType: x.inputType || 'text',
        hasMinWidth: (x.type_factory === 'toggle')
      }))}
    </div>
  ) : null;
}

ListFilterContainer.propTypes = {
  active: PropTypes.bool.isRequired,
  onValid: PropTypes.func,
  filters: PropTypes.array,
  style: PropTypes.object
}

export default ListFilterContainer;
